var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 63.000000 63.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,63.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212 568 l-93 -60 97 -63 97 -63 93 62 c52 33 94 63 93 66 0 4 -174 112 -188 117 -3 1 -48 -26 -99 -59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 346 l0 -105 84 -50 c46 -28 87 -51 90 -51 3 0 6 43 6 95 l0 94 -90 61 -90 61 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 390 l-84 -55 -1 -98 c-1 -53 1 -97 5 -97 7 0 148 86 160 98 5 5 7 53 6 108 l-3 99 -83 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 353 c2 -5 12 -26 22 -48 43 -93 -18 -182 -153 -222 -32 -10 -48 -18 -38 -21 29 -6 117 28 153 61 45 39 64 76 64 126 0 42 -27 111 -43 111 -5 0 -7 -3 -5 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 317 c-39 -94 2 -182 110 -233 28 -13 67 -24 87 -24 42 0 56 -14 36 -37 -11 -14 -11 -16 2 -11 8 2 22 17 30 31 14 25 13 28 -13 54 -15 15 -27 22 -27 16 0 -7 5 -15 10 -18 18 -11 11 -25 -13 -25 -57 0 -132 32 -173 75 -50 51 -61 95 -40 156 19 53 12 65 -9 16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.62608947a7123ca6aa2e0553f94bfabc.svg";
export { ForwardRef as ReactComponent };